// archivo axios.js
import axios from 'axios';

const instance = axios.create({
  baseURL: 'https://master.tidyng.es/api/',
  timeout: 8000
});

// Interceptor para agregar el token de autenticación automáticamente
instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("tokenUsuario");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(response => {
    return response;
}, error => {
    return Promise.reject(error);
});

export default instance;
